import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'DeviceVerify',
      component: () => import('@/views/deviceVerify.vue')
    },
    {
      path: '/deviceVerifyResult',
      name: 'DeviceVerifyResult',
      component: () => import('@/views/deviceVerifyResult.vue')
    },
    {
      path: '/securityCode',
      name: 'SecurityCode',
      component: () => import('@/views/securityCode')
    },
    {
      path: '/professional',
      name: 'Professional',
      component: () => import('@/views/professional')
    },
    {
      path: '/professionalResult',
      name: 'ProfessionalResult',
      component: () => import('@/views/professionalResult')
    },
    {
      path: '/wxScan',
      name: 'WxScan',
      component: () => import('@/views/wxScan')
    }
  ]
})
